import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import SquareIcon from "@mui/icons-material/Square";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import AddProductForm from "./AddProductForm";
import ProductMasterTable from "./ProductMasterTable";
import { IntegerFormControl } from "../../FormControl";
import { getProductDetail } from "../../../http/api/ProductDetailAPI";
import { getDisplaySize } from "../../../utils/Items";
import { validateInteger } from "../../../utils/validation";
import { inputValueToInt, stringToEmptyIfNull } from "../../../utils/utils";

const onFocusInput = (event) => {
  event.target.select();
};

const defaultPredictAddedProduct = (product, addedProduct) => {
  return product.productId === addedProduct.productId
    && product.productDetailId === addedProduct.productDetailId
}

// 商品追加ダイアログ
export default function AddProductDialog({
  open,
  onClose,
  addProduct,
  productData,
  tabPosition,
  priceTitle,
  addedProductList,
  predictAddedProduct = defaultPredictAddedProduct, 
  openAddProductMasterDialog,
  openAddProductDetailMasterDialog,
  hidePrice = false,
  hideDisplayOrder = false,
}) {
  const [part, setPart] = useState(tabPosition);

  const [selectedProductData, setSelectedProductData] = useState({
    productId: 0,
    productDetailId: 0,
    productName: "",
    origin: "",
    displaySize: "",
    orderingUnit: "",
    added: false,
  });

  const [productInfoList, setProductInfoList] = useState([]);

  //const [price, setPrice] = useState("0");
  //const [displayOrder, setDisplayOrder] = useState("1");
  const [productDataInput, setProductDataInput] = useState({
    productName: "",
    origin: "",
    displaySize: "",
    orderingUnit: "",
    price: "0",
    displayOrder: "1",
  });

  const [productAdded, setProductAdded] = useState(false);

  // 商品追加中をあらわすstate
  const [isAdding, setAdding] = useState(false);

  useEffect(() => {
    if (open) {
      setAdding(false);
      setPart(tabPosition);

      setProductDataInput({
        productName: productData ? productData.productName : "",
        origin: "",
        displaySize: "",
        orderingUnit: "",
        price: "0",
        displayOrder: productData
          ? (productData.displayOrder + 1).toLocaleString()
          : "1",
      });

      (async () => {
        let res = await getProductDetail({});
        let addedList = addedProductList
        .filter((addedData) => 
          addedData.priceDetailTypeId === tabPosition
        )

        let productInfoList = res.listProductDetailInfo.map((data) => ({
          ...data,
          displaySize: getDisplaySize(
            data.rank,
            data.productClass,
            data.weight,
            data.weightUnit,
            data.packing,
            data.quantity
          ),
          added: addedList.some(
              (addedData) =>
                predictAddedProduct(data, addedData)
            ),
        }))

        setProductInfoList(productInfoList);

        initializeProductSelectInput(productData, productInfoList)
      })();
    } else {
      setProductDataInput({
        productName: "",
        origin: "",
        displaySize: "",
        orderingUnit: "",
        price: "0",
        displayOrder: "1",
      });
    }
  }, [open]);

  const initializeProductSelectInput = (productData, productInfoList) => {
    let newProductData = productData;

    if (productData.productId && productData.productDetailId) {
      newProductData = productInfoList.find((productInfo) => 
        productInfo.productId === productData.productId
        && productInfo.productDetailId === productData.productDetailId
      );      
    }

    setSelectedProductData({
      productId: productData.productId ? productData.productId: 0,
      productDetailId: productData.productDetailId ? productData.productDetailId : 0,
      productName: newProductData ? newProductData.productName : "",
      origin: newProductData ? newProductData.origin : "",
      displaySize: newProductData ? newProductData.displaySize: "",
      orderingUnit: newProductData ? newProductData.orderingUnit: "",
      added: false,
    });

    setProductDataInput({
      productName: newProductData ? newProductData.productName : "",
      origin: newProductData ? newProductData.origin : "",
      displaySize: newProductData ? newProductData.displaySize: "",
      orderingUnit: newProductData ? newProductData.orderingUnit: "",
      price: productData && productData.marketPrice ? productData.marketPrice.toString() : "0",
      displayOrder: productData && productData.displayOrder
        ? (productData.displayOrder + 1).toLocaleString()
        : "1",
    });
  }

  const selectProductData = (data) => {
    setSelectedProductData(data);
    setProductDataInput({
      ...productDataInput,
      productName: data.productName,
      origin: data.origin,
      displaySize: data.displaySize ? data.displaySize : "",
      orderingUnit: data.orderingUnit ? data.orderingUnit : "",
    });
  };

  const updateProductDataInput = (prop) => (value) => {
    var newProductData = { ...productDataInput, [prop]: value };
    setProductDataInput(newProductData);
  };

  const areSameProducts = (productData_a, productData_b) => {
    return (
      productData_a.productName === productData_b.productName &&
      stringToEmptyIfNull(productData_a.origin) ===
        stringToEmptyIfNull(productData_b.origin) &&
      stringToEmptyIfNull(productData_a.displaySize) ===
        stringToEmptyIfNull(productData_b.displaySize) &&
      stringToEmptyIfNull(productData_a.orderingUnit) ===
        stringToEmptyIfNull(productData_b.orderingUnit)
    );
  };

  const onClickAddProduct = (event) => {

    setAdding(true);

    let addProductData = {
      ...productDataInput,
      productId: 0,
      productDetailId: 0,
    };

    if (areSameProducts(selectedProductData, productDataInput)) {
      addProductData.productId = selectedProductData.productId;
      addProductData.productDetailId = selectedProductData.productDetailId;
    }

    addProduct(
      addProductData,
      part,
      inputValueToInt(productDataInput.price),
      inputValueToInt(productDataInput.displayOrder)
    );
    onClose(event);
  };

  const handleChangePart = (event) => {
   let part = event.target.value

    if (!part) {
      return;
    }
    
    setPart(part);

    let addedList = addedProductList
        .filter((addedData) => 
          addedData.priceDetailTypeId === part
        )

    setProductInfoList(
      productInfoList.map((data) => ({
        ...data,
        added: addedList.some(
            (addedData) =>
              addedData.productId === data.productId &&
              addedData.productDetailId === data.productDetailId
        ),
      })
    ))
  };

  const validateAddProduct = () => {
    return (
      productDataInput.productName &&
      productDataInput.origin &&
      validateInteger(productDataInput.price) &&
      validateInteger(productDataInput.displayOrder) &&
      inputValueToInt(productDataInput.displayOrder) > 0 &&
      !productAdded &&
      areSameProducts(selectedProductData, productDataInput)
    );
  };

  const isCorrespondProductSearch = (productData, productSearchCondition) => {
    // 商品名nullの場合、false　(回避対応)
    if (!productData.productName) {
      return false;
    }
    if (!productSearchCondition.productName) {
      return true;
    }

    return (
      productData.productName.indexOf(productSearchCondition.productName) >= 0
    );
  };

  const onClickAddProductMaster = (event) => {
    openAddProductMasterDialog({
      ...productDataInput,
      productId: selectedProductData.productId,
      productDetailId: selectedProductData.productDetailId,
      marketPrice: 0,
      displayOrder: inputValueToInt(productDataInput.displayOrder) - 1,
    });
  }
  
  const onClickAddProductDetailMaster = (event) => {
    let productDataInList = productInfoList.find((data) => data.productName === productDataInput.productName);

    openAddProductDetailMasterDialog({
      ...productDataInput,
      productId: productDataInList.productId,
      marketPrice: 0,
      displayOrder: inputValueToInt(productDataInput.displayOrder) - 1,
    });
  }

  const existproductOfName = (name) => {
    return productInfoList.some((data) => data.productName === name);
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <Box padding={2}>
        <Typography fontSize={20} fontWeight={700}>
          商品追加
        </Typography>
        <Box marginTop={2} marginBottom={2}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs="auto">
              <SquareIcon />
            </Grid>
            <Grid item xs="auto">
              <Typography>価格表種別:</Typography>
            </Grid>
            <Grid item xs>
              <Select
                value={part}
                onChange={handleChangePart}
                input={<OutlinedInput />}
              >
                <MenuItem key={1} value={1}>
                  蔬菜
                </MenuItem>
                <MenuItem key={2} value={2}>
                  果物
                </MenuItem>
                <MenuItem key={3} value={3}>
                  スポット
                </MenuItem>
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="contained"
                onClick={onClickAddProductMaster}
                disabled={existproductOfName(productDataInput.productName)}
              >
                商品を追加
              </Button>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="contained"
                onClick={onClickAddProductDetailMaster}
                disabled={!existproductOfName(productDataInput.productName)}
              >
                商品明細を追加
              </Button>
            </Grid> 
          </Grid>
        </Box>
        <Box>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs="auto">
              <SquareIcon />
            </Grid>
            <Grid item xs="auto">
              <Typography>追加する商品を入力</Typography>
            </Grid>
          </Grid>

          <Box margin={2} marginTop={0}>
            <AddProductForm
              productInfoList={productInfoList}
              productDataInput={productDataInput}
              disableProductName={false}
              setProductDataInput={setProductDataInput}
              setProductAdded={setProductAdded}
            />

            <Box height={15} marginTop={1}>
              <Typography color="error" fontSize={15}>
                {productAdded ? "入力された商品は既に追加されています" : ""}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box margin={2} height={200}>
          <ProductMasterTable
            dataList={productInfoList.filter((data) =>
              isCorrespondProductSearch(data, productDataInput)
            )}
            selectProductData={selectProductData}
          />
        </Box>
        
        {!hidePrice &&
          <Box marginBottom={2}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs="auto">
                <SquareIcon />
              </Grid>
              <Grid item xs="auto">
                <Typography>{priceTitle}:</Typography>
              </Grid>
              <Grid item xs="auto">
                <IntegerFormControl
                  value={productDataInput.price}
                  setValue={updateProductDataInput("price")}
                  inputProps={{ min: "0", step: "1", sx: { textAlign: "right" } }}
                  inputSx={{ width: 100 }}
                  helperTextSx={{ margin: 0 }}
                />
              </Grid>
            </Grid>
          </Box>
        }

        {!hideDisplayOrder && <Box marginBottom={2}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs="auto">
              <SquareIcon />
            </Grid>
            <Grid item xs="auto">
              <Typography>表示順:</Typography>
            </Grid>
            <Grid item xs="auto">
              <IntegerFormControl
                value={productDataInput.displayOrder}
                setValue={updateProductDataInput("displayOrder")}
                inputProps={{ min: "1", step: "1", sx: { textAlign: "right" } }}
                inputSx={{ width: 100 }}
                helperTextSx={{ margin: 0 }}
              />
            </Grid>
          </Grid>
        </Box>}

        <Grid container>
          <Grid item xs textAlign="center">
            <Button
              variant="contained"
              color="error"
              onClick={onClickAddProduct}
              disabled={!validateAddProduct() || isAdding}
            >
              追加
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onClose}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
